export const REGISTER_USER = "REGISTER_USER"
export const REGISTER_USER_SUCCESSFUL = "REGISTER_USER_SUCCESSFUL"
export const REGISTER_USER_FAILED = "REGISTER_USER_FAILED"
export const RESET_REGISTER_FLAG = "RESET_REGISTER_FLAG";
